import { gql } from "@apollo/client"; // saveVisitaNpidMedico.js

import { adaptIndicacionVisitaBAPInput } from "../../../../Pages/MisVisitasCreation/utils/adaptSubModelsInput";

const SAVE_VISITA_NPID_MEDICO = gql`
  mutation saveVisitaNpidMedico($input: AddVisitaNpidMedicoInput!) {
    saveVisitaNpidMedico(input: $input) {
      idVisita
      idVisitaNpid
    }
  }
`;

export default SAVE_VISITA_NPID_MEDICO;

export const adaptAddVisitaNpidMedicoInput = (data) => ({
  idVisitaNpid: data?.idVisitaNpid,
  idComboRIValorAcceso: data?.idComboRIValorAcceso,
  fechaColocacion: data?.fechaColocacion,
  idComboRIValorUbicacion: data?.idComboRIValorUbicacion,
  idComboRIValorLumenes: data?.idComboRIValorLumenes,
  insercionNormal: !!data?.insercionNormal,
  justificacionInsercion: data?.justificacionInsercion,
  indicacionComentario: data?.indicacionComentario,
  proteinasTotales: data?.proteinasTotales,
  lipidosTotales: data?.lipidosTotales,
  caloriasTotales: data?.caloriasTotales,
  idIndicacionVisitaBAP: data?.idIndicacionVisitaBAP,
  diasConexionSemanaMagistral: data?.diasConexionSemanaMagistral,
  diasConexionSemanaEstandar: data?.diasConexionSemanaEstandar,
  indicacionVisitaBAP: adaptIndicacionVisitaBAPInput(data),
  complicaciones: data?.complicaciones,
  idVisita: data?.idVisita
});